import React from 'react';
import { FaGithub, FaLinkedinIn, FaInstagram, FaFigma, FaAndroid } from 'react-icons/fa';

const HeaderSocials = () => {
    return (
        <div className='home__socials'>
            <a href='https://github.com/AbhaySahgal' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaGithub />
            </a>

            <a href='https://www.linkedin.com/in/abhaysahgal/' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaLinkedinIn />
            </a>
            
            <a href='https://www.figma.com/@abhaysahgal' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaFigma />
            </a>

            <a href='https://targetofficial.vercel.app/' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaAndroid />
            </a>

            <a href='https://www.instagram.com/sahgal_abhay/' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaInstagram />
            </a>

        </div>
    );
};

export default HeaderSocials;
